import { styled } from '@mui/system';
import { Typography } from '@mui/material';
import NoPatientCard from '../messenger-widget/start-sms/no-patient-card';
import { ContactSearchByNumber } from '../../../../services/api-client/contact-api';
import SelectPatientCard from './select-patient-card';

const Container = styled('div')({
  height: '100%',
  width: '100%',
  backgroundColor: '#fff'
});

const TitleContainer = styled('div')({
  width: '100%',
  borderBottom: '1px solid #E1E4E7'
});

const Title = styled(Typography)({
  fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
  fontStyle: 'normal',
  marginLeft: 16,
  marginBottom: 12,
  fontSize: 20,
  fontWeight: 500,
  lineHeight: '28px',
  color: '#000',
  padding: '8px 12px'
});

interface SelectPatientWidgetProps {
  contacts: ContactSearchByNumber[];
}

export default function SelectPatientWidget({ contacts }: SelectPatientWidgetProps) {
  return (
    <Container>
      <TitleContainer>
        <Title variant='h3'>Select Patient</Title>
      </TitleContainer>
      {contacts.length > 0 ? (
        contacts.map(contact => {
          return <SelectPatientCard key={contact.id} contactInfo={contact} />;
        })
      ) : (
        <NoPatientCard searching={false} />
      )}
    </Container>
  );
}
